export default {
  en: {
    'components.invite-user-form.error.first-name': 'Please enter a first name',
    'components.invite-user-form.error.last-name': 'Please enter a last name',
    'components.invite-user-form.error.mobile': 'Please enter a mobile number',
    'components.invite-user-form.error.password': 'Please enter a password',
    'components.invite-user-form.error.password-invalid':
      'Your password must contain 8 chars, 1 upper, 1 lower, 1 special char',
    'components.invite-user-form.continue': 'Continue',
    'components.invite-user-form.terms-and-conditions': 'Terms & Conditions',
    'components.invite-user-form.privacy-policy': 'Privacy Policy',
    'components.invite-user-form.consent':
      'By clicking continue you agree with our {termsLink} and {privacyPolicy}.',
    'components.invite-user-form.label.mobile': 'Mobile Number',
    'components.invite-user-form.label.email': 'Email address',
    'components.invite-user-form.label.last-name': 'Last Name',
    'components.invite-user-form.label.first-name': 'First Name',
    'components.invite-user-form.label.country-code': 'Country Code',
    'components.invite-user-form.error.country': 'Country code is required',
    'components.invite-user-form.label.email-message':
      'Complete your registration for {link} below.',
    'components.invite-user-form.save-failed': 'Failed to save your user details.',
    'components.invite-user-form.retrieve-invite-failed':
      'An error occurred while retrieving your invitation. Please try again.',
  },
};
